module.exports = __webpack_public_path__ + "5490d11fa8c7ece509e12c7c2cf45fda.png";